import { createFileRoute } from '@tanstack/react-router'

import { ImplementationsListPage } from '#features/admin/implementations/implementations-list-page'

export const Route = createFileRoute('/_app/admin/implementations/')({
  component: ImplementationsListPage,
})
